import { createSlice } from "@reduxjs/toolkit";
const initialState = {
  showAddClientButton: localStorage.getItem('role') && JSON.parse(localStorage.getItem("role")) !== "Financial Advisor Client" ? true : false,
  delegateUsers: localStorage.getItem('delegateUsers') ? JSON.parse(localStorage.getItem("delegateUsers")) : [],
};
// A slice for inventory with our 2 reducers
const financialAdvisorSlice = createSlice({
  name: "financialAdvisorState",
  initialState,
  reducers: {
    setAddClientButton: (state,action) => {
      state.showAddClientButton = action.payload;
    },
    setDelegateUsers: (state,action) => {
      
        console.log("payload =>>>>>>>>",action.payload)
      state.delegateUsers = action.payload;
    }
  },
});
// Two actions generated from the slice
export const { setAddClientButton, setDelegateUsers} = financialAdvisorSlice.actions;
// The reducer
export default financialAdvisorSlice.reducer;